var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { class: _vm.rowClass }, [
    _c(
      "td",
      {
        staticClass:
          "kpi-performance-table__endColGroup kpi-performance-table__metric--name"
      },
      [_vm._v(_vm._s(_vm.name))]
    ),
    _c("td", [_vm._v(_vm._s(_vm.actualValue))]),
    _c("td", [_vm._v(_vm._s(_vm.benchmarkValue))]),
    _c("td", [_vm._v(_vm._s(_vm.previousValue))]),
    _c("td", { class: _vm.benchmarkVarianceClass }, [
      _vm._v(_vm._s(_vm.benchmarkValueDiff))
    ]),
    _c(
      "td",
      {
        staticClass: "kpi-performance-table__endColGroup",
        class: _vm.previousYearVarianceClass
      },
      [_vm._v(_vm._s(_vm.previousYearValueDiff))]
    ),
    _c("td", [_vm._v(_vm._s(_vm.actualYtd))]),
    _c("td", [_vm._v(_vm._s(_vm.benchmarkYtd))]),
    _c("td", [_vm._v(_vm._s(_vm.previousYtd))]),
    _c("td", { class: _vm.benchmarkYtdVarianceClass }, [
      _vm._v(_vm._s(_vm.benchmarkYtdValueDiff))
    ]),
    _c(
      "td",
      {
        staticClass: "kpi-performance-table__endColGroup",
        class: _vm.previousYtdVarianceClass
      },
      [_vm._v(_vm._s(_vm.previousYtdValueDiff))]
    ),
    _c("td", { class: "comments_" + _vm.field }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: { content: _vm.comment, html: true },
              expression: "{ content:comment, html:true }"
            }
          ]
        },
        [_vm._v(_vm._s(_vm.commentShort))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }